/* Purpose: Can view and edit Scope of Work data 
 * Props: loanRequInfoList (list of map)
 *          handleRadioChange(func)
 *          handleTextInfoChange (func)
 *          onBlur (func)
 *          stopSave (boolean)
 *          handleClickSave (func)
 *          saveBtnText (str)
 *          next (func)
 *          back (func)
 * Author: R. Markowitz (April 2025)
 * Dev Notes: Scope Of Work data is part of the required loan info for all FAF loans. 
            It has been seperated from the rest of the required loan info for clarity and aesier UX
*/

import React, {useState, useEffect} from "react";
import {Container, Form, Row, Col, Alert} from 'react-bootstrap';
import { Link } from "react-router-dom";
import SubmitButton from "./Button";

const ScopeOfWorkForm = ({loanRequInfoList, handleRadioChange, handleTextInfoChange, onBlur, stopSave, handleClickSave, saveBtnText, next, back}) => {
    const [SOWBudgetTotal, setSOWBudgetTotal] = useState(0);
    
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, [])
    
    // When loanRequInfoList is updated, Update SOWBudgetTotal
    useEffect(() => {
        // Set SOWBudgetTotal
        let tempTotal = 0;
        loanRequInfoList.map((field) => {
            if ((field.notes && field.notes.includes("SOW")) && field.fieldName.includes("Budget") && field.value){
                let tempValue = field.value;
                tempValue = tempValue.replace("$", "");
                tempValue = tempValue.replace(",","");
                tempTotal += +tempValue;
            }
        })
        if(tempTotal.toString() == "NaN"){
            tempTotal = "Invalid Budget"
        } else{
            tempTotal = "$ " + tempTotal.toFixed(2);
        }
        

        setSOWBudgetTotal(tempTotal);
    }, [loanRequInfoList]);

    return(
        <Container className = 'm-3'>
            <Form className='m-3'>
                <Row xs={2} md={2} className="g-4 mb-4">
                    <Col className="col-md-3">
                        <Form.Label><strong>Budget Total:</strong></Form.Label>
                    </Col>   
                    <Col className="col-md-3">
                        <Form.Control disabled id = "Budget Total" value = {SOWBudgetTotal} />
                    </Col>
                </Row>

                <Row xs={1} md={2} noValidate>
                {loanRequInfoList && loanRequInfoList.map((item, index) => (
                <>
                    {item.notes && item.notes.includes("SOW") && (
                        <Col key ={index} className={"my-1 " + ((item.fieldName.includes("Budget"))?("SOW-Budget col-md-3"):("SOW-Description col-md-9"))} >
                        
                        {item.fieldType === "radio" ? (
                            <Form.Group type = "radio" key = {index}>
                            <Form.Label>{item.fieldName}: </Form.Label>
                            {item.options.map((option, optionIndex) => (
                                <Form.Check 
                                    key = {optionIndex}
                                    type = "radio" 
                                    name = {item.fieldName}
                                    id = {item.fieldName + "-" + option} 
                                    label = {option}
                                    value = {item.value}
                                    checked = {item.value === option}
                                    onChange = {(event) => handleRadioChange(index, event, option)}
                                />
                            ))} 
                            </Form.Group>
                        ):(item.fieldType == "text" && (
                            <Form.Group key = {index} type="text" > 
                            <Form.Label>{item.fieldName}: </Form.Label>
                            <Form.Control 
                                id={"SOW-" + item.fieldName} 
                                value= {item.value} 
                                disabled = {item.state === "disabled"}
                                placeholder={item.state?item.placeHolder:item.value}
                                onChange={(event) => {handleTextInfoChange(index, event)}}
                                isInvalid = {"isValid" in item?!item.isValid:false}
                                onBlur={() => onBlur(item, index)}
                            />
                            {item.toolTip &&(
                                <Form.Text id = {item.fieldName} muted>{item.toolTip}</Form.Text>
                            )}
                            <Form.Control.Feedback type = "invalid">{item.invalidMsg}</Form.Control.Feedback>
                        </Form.Group>
                        ))}
                        </Col>)}
                    
                </>
                ))}
                </Row>
            </Form>

            {stopSave && (
              <Row className="align-items-center mt-3">
                <Alert className = "text-center w-80" variant = "danger" >Your changes have NOT been saved. One or more fields contain invalid data. Please fix your data and try saving again.</Alert>
              </Row>
            )}
            
            <Row  xs = {2} sm={2} md = {3} className='g-4 m-2'>
                <Col className='text-start' xs={{order: 2}} md = {{order: 1}}>
                    <Link className="mt-auto" onClick = {back}><SubmitButton text = "<< Back" width = "52"/></Link>
                </Col>
                <Col className='text-center' xs = {{span: '12', order: 1}} sm ={{span: '12', order: 1}} md = {{order: 2}}>
                    <SubmitButton text = {saveBtnText} onClick = {handleClickSave} width = "90"/>
                </Col>
                <Col className='text-end' xs = {{order: 3}} md = {{order: 3}}>
                    <Link onClick = {next} className="mt-auto"><SubmitButton text = "Next >>" width = "52"/></Link>
                </Col>
            </Row>
        </Container>
        
    )
};

export default ScopeOfWorkForm